var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#camera_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 90c22.091 0 40-17.909 40-40S72.091 10 50 10 10 27.909 10 50s17.909 40 40 40Z",
    fill: "#ECECEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.781 60.8H38.22A1.21 1.21 0 0 1 37 59.6V44.892c0-.663.545-1.2 1.219-1.2h5.205l1.952-3.214c.222-.288.571-.478.968-.478h7.312c.343 0 .65.14.872.364l.001-.002 2.07 3.33h5.182a1.21 1.21 0 0 1 1.219 1.2V59.6c0 .663-.545 1.2-1.219 1.2ZM50 46.153c-3.556 0-6.438 2.838-6.438 6.339 0 3.5 2.883 6.339 6.438 6.339 3.556 0 6.438-2.838 6.438-6.34 0-3.5-2.882-6.338-6.438-6.338Zm-3.726 6.339c0 2.026 1.669 3.668 3.726 3.668 2.058 0 3.726-1.642 3.726-3.668 0-2.026-1.668-3.668-3.726-3.668-2.057 0-3.726 1.642-3.726 3.668Z",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "camera_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 40,
    width: 26,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.781 60.8H38.22A1.21 1.21 0 0 1 37 59.6V44.892c0-.663.545-1.2 1.219-1.2h5.205l1.952-3.214c.222-.288.571-.478.968-.478h7.312c.343 0 .65.14.872.364l.001-.002 2.07 3.33h5.182a1.21 1.21 0 0 1 1.219 1.2V59.6c0 .663-.545 1.2-1.219 1.2ZM50 46.153c-3.556 0-6.438 2.838-6.438 6.339 0 3.5 2.883 6.339 6.438 6.339 3.556 0 6.438-2.838 6.438-6.34 0-3.5-2.882-6.338-6.438-6.338Zm-3.726 6.339c0 2.026 1.669 3.668 3.726 3.668 2.058 0 3.726-1.642 3.726-3.668 0-2.026-1.668-3.668-3.726-3.668-2.057 0-3.726 1.642-3.726 3.668Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "camera_svg__a",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_19467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_19467",
    result: "shape"
  })))));
};

export default SvgCamera;